import orderService from '../../api/order'
import examService from '@/api/exam'
import sampleService from '@/api/sample'
import {
  OS_SET_CLONE,
  OS_SET_LOADING_STATUS,
  OS_SET,
  OS_INCREASE_OFFSET,
  OS_SET_MODIFIED,
  OS_SET_ERROR,
  OS_SET_CORRECT,
  OS_DELETE,
  OS_CLEAR_ALL,
  OS_LOADING_DETAILS,
  OS_LOADING_DETAILS_SUCCESS,
  OS_LOADING_DETAILS_ERROR,
  OS_CLEAR,
  OS_CLEAR_OFFSET,
  OS_ADD_NEW_PATIENT,
  OS_EDIT_NEW_PATIENT,
  OS_CLEAR_NEW_ORDER_DATA,
  OS_DELETE_EXAM_ORDER,
  OS_SET_LIST,
  EXAM_CLEAR_NEW_DATA,
  EXAM_ADD_NEW,
  OS_SET_VERSION,
  OS_FILTER_SHOW_OFF,
  OS_SORT_LIST,
  OS_TOTAL_COUNT,
  OS_BREAK_STATUS,
  OS_EDITING_STATUS,
  OS_SET_LAST_TRANSFERED_LIST,
  OS_SET_TRANSFER_REPORT,
  OS_SET_TRANSFER_REPORT_LOADING,
  OS_CLEAR_LAST_TRANSFERED_LIST,
  OS_SET_TOTAL_EXAMS_DOC_PENDING,
  OS_SET_PATIENT_ROUTINE,
  OS_CONSENT_FORM,
  OS_EXAM_NUMBER,
  OS_SET_PENDING_DOCUMENTS_TOTAL,
} from '../types'
import notify from '@/api/notification'
import strings from '../../strings'
import router from '../../router'
import analytics from '@/api/analytics'
import { getCookie } from '../../utils/auth-utils'
import { deepCloneObj } from '../../utils/object-utils'
import { sortColumn } from '../../utils/sort-columns'
import Moment from 'moment'

const ERROR_TRANSFER_OS = 'Erro ao trasmitir OS. Por favor, tente novamente.'
const ERROR_DELETE_EXAM_ORDER = 'Erro ao tentar excluir exame.'
const EXAM_SIMPLE = 'S'
const EXAM_ADITIONAL = 'A'
const EXAM_CURVE = 'C'

const state = {
  orderLoadingStatus: 'STATUS_INITIAL',
  orders: [],
  exam: null,
  offset: 0,
  correctOrders: 0,
  errorOrders: 0,
  modifiedOrders: 0,
  version: null,
  newPatient: {
    editing: true,
  },
  profile: getCookie('profile') || null,
  filterBy: null,
  q: null,
  idFile: null,
  docDelivered: null,
  findTypeOrderResultFilter: null,
  lastReordenationOrder: {
    sort: null,
    column: null,
  },
  totalOrdersCount: 0,
  filterShowOff: false,
  breakStatusOrders: false,
  isEditingOrder: false,
  lastTransferedList: [],
  transferReports: {
    samplesCount: 0,
    failTransmitOrdersCount: 0,
  },
  transferReportsLoadingStatus: 'STATUS_INITIAL',
  totalOrdersExamsWithDocumentsPending: 0,
  orderClone: null,
  patientRoutine: false,
  consentForm: null,
  pendingDocumentsTotal: 0,
}

const mutations = {
  [OS_SET_PATIENT_ROUTINE](state, patientRoutine) {
    state.patientRoutine = patientRoutine
  },
  [OS_SET_CLONE](state, orderClone) {
    state.orderClone = orderClone
  },
  [OS_SET_LOADING_STATUS](state, orderLoadingStatus) {
    state.orderLoadingStatus = orderLoadingStatus
  },
  [OS_SET](state, orders) {
    state.orders = state.orders.concat(orders)
  },
  [OS_SET_MODIFIED](state, modifiedOrders) {
    state.modifiedOrders = modifiedOrders
  },
  [OS_SET_ERROR](state, errorOrders) {
    state.errorOrders = errorOrders
  },
  [OS_SET_CORRECT](state, correctOrders) {
    state.correctOrders = correctOrders
  },
  [OS_SET_VERSION](state, version) {
    state.version = version
  },
  [OS_INCREASE_OFFSET](state) {
    state.offset++
  },
  [OS_DELETE](state, index) {
    if (state.orders[index].status === 'C') {
      state.correctOrders--
    } else if (state.orders[index].status === 'E') {
      state.errorOrders--
    } else if (state.orders[index].status === 'F') {
      state.modifiedOrders--
    }

    state.orders.splice(index, 1)
  },
  [OS_CLEAR_ALL](state) {
    state.orders = []
    state.offset = 0
    state.correctOrders = 0
    state.errorOrders = 0
    state.modifiedOrders = 0
  },
  [OS_LOADING_DETAILS](state, index) {
    state.orders[index].expanded = !state.orders[index].expanded
    if (state.orders[index].expanded) {
      state.orders[index].loading = true
    }
  },
  [OS_LOADING_DETAILS_SUCCESS](state, object) {
    state.orders[object.index].exams = object.orderDetails.exams
    state.orders[object.index].loading = false
  },
  [OS_LOADING_DETAILS_ERROR](state, index) {
    state.orders[index].loading = false
    state.orders[index].expanded = false
    notify({
      title: 'AVISO:',
      message: 'Erro ao carregar os detalhes da Ordem de Serviço.',
    })
  },
  [OS_CLEAR](state) {
    state.orders = []
  },
  [OS_CLEAR_OFFSET](state) {
    state.offset = 0
  },
  [OS_ADD_NEW_PATIENT](state, patient) {
    state.newPatient = patient
  },
  [OS_EDIT_NEW_PATIENT](state) {
    state.newPatient.editing = true
  },
  [OS_CLEAR_NEW_ORDER_DATA](state) {
    state.newPatient = {
      editing: true,
    }
    state.version = null
    state.orderClone = null
  },
  [OS_DELETE_EXAM_ORDER](state, object) {
    let indexExam = state.orders[object.indexOrder].exams.indexOf(object.exam)
    let examDeleted = state.orders[object.indexOrder].exams[indexExam]
    state.orders[object.indexOrder].exams.splice(indexExam, 1)
    if (
      state.orders[object.indexOrder].status !==
      state.orders[object.indexOrder].exams[0].status
    ) {
      // Decrementa contador caso status da order for diferente de exame
      if (state.orders[object.indexOrder].status === 'C') {
        state.correctOrders--
      } else if (state.orders[object.indexOrder].status === 'E') {
        state.errorOrders--
      } else if (state.orders[object.indexOrder].status === 'F') {
        state.modifiedOrders--
      }
      // Incremetna contador do status a qual OS passa a ser
      if (state.orders[object.indexOrder].exams[0].status === 'C') {
        state.correctOrders++
      } else if (state.orders[object.indexOrder].exams[0].status === 'E') {
        state.errorOrders++
      } else if (state.orders[object.indexOrder].exams[0].status === 'F') {
        state.modifiedOrders++
      }
      // Atualiza status da OS para o status de maior relevancia
      state.orders[object.indexOrder].status =
        state.orders[object.indexOrder].exams[0].status
    }
    // Diminui numero do total de exames com documento pendente da OS, caso o exame excluído
    // esteja nesse status
    if (examDeleted.doc_delivered === false && examDeleted.docRequired === true) {
      state.orders[object.indexOrder].pendingDocCount--
    }
  },
  [OS_SET_LIST](state, query) {
    state.orders = []
    state.offset = 0
    state.filterBy = query.filterBy
    state.q = query.q
    state.idFile = query.idFile
    state.docDelivered = query.docDelivered
    state.findTypeOrderResultFilter = query.findTypeOrderResultFilter
  },
  [OS_SORT_LIST](state, param) {
    state.lastReordenationOrder = param
    let sortAlphanumeric

    // Verifica qual tipo de coluna (se possui child ou length)
    if (param.columnChild === null) {
      sortAlphanumeric = sortColumn(param.column, param.columnChild, 'one-field-level')
    } else if (param.columnChild === 'length') {
      sortAlphanumeric = sortColumn(param.column, param.columnChild, 'length')
    } else {
      sortAlphanumeric = sortColumn(param.column, param.columnChild, 'two-field-level')
    }

    // Executa a ordenação
    let temporaryArray = state.orders
    state.orders = []

    if (param.sort === 'asc') {
      state.orders = temporaryArray.sort(sortAlphanumeric)
    } else {
      state.orders = temporaryArray.reverse(sortAlphanumeric)
    }
  },
  [OS_TOTAL_COUNT](state, count) {
    state.totalOrdersCount = count
  },
  [OS_BREAK_STATUS](state, value) {
    state.breakStatusOrders = value
  },
  [OS_FILTER_SHOW_OFF](state, value) {
    state.filterShowOff = value
  },
  [OS_EDITING_STATUS](state, value) {
    state.isEditingOrder = value
  },
  [OS_SET_LAST_TRANSFERED_LIST](state, value) {
    state.lastTransferedList = value
  },
  [OS_SET_TRANSFER_REPORT](state, value) {
    state.transferReports = value
  },
  [OS_SET_TRANSFER_REPORT_LOADING](state, value) {
    state.transferReportsLoadingStatus = value
  },
  [OS_CLEAR_LAST_TRANSFERED_LIST](state) {
    state.lastTransferedList = null
  },
  [OS_SET_TOTAL_EXAMS_DOC_PENDING](state, value) {
    state.totalOrdersExamsWithDocumentsPending = value
  },
  [OS_CONSENT_FORM](state, value) {
    state.consentForm = value
  },
  [OS_EXAM_NUMBER](state, value) {
    state.exam = value
  },
  [OS_SET_PENDING_DOCUMENTS_TOTAL](state, value) {
    state.pendingDocumentsTotal = value
  },
}

const getters = {
  patientRoutine: state => {
    return state.patientRoutine
  },
  orderClone: state => {
    return state.orderClone
  },
  orderLoadingStatus: state => {
    return state.orderLoadingStatus
  },
  orders: state => {
    return state.orders
  },
  offset: state => {
    return state.offset
  },
  correctOrders: state => {
    return state.correctOrders
  },
  errorOrders: state => {
    return state.errorOrders
  },
  modifiedOrders: state => {
    return state.modifiedOrders
  },
  version: state => {
    return state.version
  },
  hasOrders: state => {
    return state.orders && state.orders.length > 0
  },
  isConsentForm: state => {
    return state.consentForm
  },
  isExamNumber: state => {
    return state.exam
  },
  loading: state => {
    return state.orderLoadingStatus === 'STATUS_INITIAL'
  },
  isNewPatientFilled: state => {
    if (state.newPatient.editing) {
      return false
    }
    return true
  },
  totalOrders: state => {
    return state.totalOrdersCount
  },
  ordersBreakStatus: state => {
    return state.breakStatusOrders
  },
  isOrderFilterShowing: state => {
    return state.filterShowOff
  },
  isEditingOrder: state => {
    return state.isEditingOrder
  },
  transferReports: state => {
    return state.transferReports
  },
  transferReportLoadingStatus: state => {
    return state.transferReportsLoadingStatus
  },
  totalOrdersExamsWithDocumentsPending: state => {
    return state.totalOrdersExamsWithDocumentsPending
  },
  pendingDocumentsTotal: state => {
    return state.pendingDocumentsTotal
  },
}

const actions = {
  orderPatientRoutine: ({ commit }, patientRoutine) => {
    commit(OS_SET_PATIENT_ROUTINE, patientRoutine)
  },
  orderCanBeCloned: ({ dispatch }, id) => {
    return dispatch('getExamDetails', { id })
  },
  setOrderClone: ({ commit }, order) => {
    commit(OS_SET_CLONE, order)
  },
  getServiceOrder: function ({ commit, dispatch, state }) {
    commit(OS_BREAK_STATUS, false)
    let filter = builderStatusAndStates(state.filterBy)
    let lastTransferedList = state.filterBy === 'F' ? state.lastTransferedList : []

    return orderService
      .getAllOrders(
        state.offset,
        strings.listsLimits.orders,
        filter.status,
        filter.states,
        state.q,
        state.idFile,
        lastTransferedList,
        state.docDelivered,
        state.findTypeOrderResultFilter,
        state.patientRoutine
      )
      .then(response => {
        let orders = response.data
        let headers = response.headers
        if (orders && orders.length > 0) {
          orders = orders.map(item => {
            item.expanded = false
            item.loading = false
            return item
          })

          if (
            filter.states ||
            filter.status ||
            state.q ||
            state.idFile ||
            state.docDelivered
          ) {
            let query = {
              states: filter.states,
              status: filter.status,
              q: state.q,
              idFile: state.idFile,
              docDelivered: state.docDelivered,
            }
            analyticsOnFetchingFromSearch(query)
          }

          analyticsOnTransmittedOrders(headers['content-order-transmitted-number'])
          analyticsOnReloadPage()

          commit(OS_SET, orders)
          commit(OS_INCREASE_OFFSET)
          if (orders.length === strings.listsLimits.orders) {
            commit(OS_SET_LOADING_STATUS, 'STATUS_SUCCESS')
          } else {
            commit(OS_SET_LOADING_STATUS, 'STATUS_END')
          }
          commit(OS_SET_MODIFIED, headers['content-modified-number'])
          commit(OS_SET_ERROR, headers['content-error-number'])
          commit(OS_SET_CORRECT, headers['content-correct-number'])
          if (state.lastReordenationOrder.sort !== null) {
            commit(OS_SORT_LIST, state.lastReordenationOrder)
          }
        } else {
          commit(OS_SET_LOADING_STATUS, 'STATUS_END')
        }
        dispatch('countTotalOrdersWithDocPending')
        commit(OS_CLEAR_LAST_TRANSFERED_LIST)
      })
      .catch(() => {
        commit(OS_SET_LOADING_STATUS, 'STATUS_FAILED')
      })
  },
  getServiceOrderDetails: function ({ commit, dispatch, state }, index) {
    let id = state.orders[index].id
    return orderService
      .getOrderDetails(id)
      .then(response => {
        let orderDetails = decorateOrderDetail(response.data)
        commit(OS_LOADING_DETAILS_SUCCESS, { orderDetails, index })
      })
      .catch(() => {
        commit(OS_LOADING_DETAILS_ERROR, index)
      })
  },
  setInitialLoadingStatus: function ({ commit }) {
    commit(OS_SET_LOADING_STATUS, 'STATUS_INITIAL')
  },
  clearAllOrderData: function ({ commit }) {
    commit(OS_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(OS_CLEAR)
    commit(OS_CLEAR_OFFSET)
    commit(OS_SET_MODIFIED, 0)
    commit(OS_SET_ERROR, 0)
    commit(OS_SET_CORRECT, 0)
  },
  deleteSelectedOrders({ commit, state }, index) {
    commit(OS_DELETE, index)
  },
  deleteOrder({ commit, state }, index) {
    let id = state.orders[index].id
    return orderService
      .deleteOrder(id)
      .then(response => {
        commit(OS_DELETE, index)
        notify({
          title: 'AVISO: ',
          message: 'Ordem de serviço excluída com sucesso.',
        })
      })
      .catch(response => {
        commit(OS_SET_LOADING_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Não foi possível excluir a OS. Por favor, tente novamente.',
        })
      })
  },
  loadingDetails: function ({ commit, dispatch }, index) {
    commit(OS_LOADING_DETAILS, index)
    if (state.orders[index].expanded) {
      dispatch('getServiceOrderDetails', index)
    }
  },
  performTransferButton: function ({ dispatch, rootState }, selectedItems, status) {
    return new Promise((resolve, reject) => {
      if (status === 'E') {
        notify({
          title: 'AVISO:',
          message: 'As Ordens de Serviço com erro serão transferidas parcialmente.',
        })
      }
      let selectedItemsValue = [selectedItems]
      orderService
        .performTransfer(selectedItemsValue)
        .then(() => {
          resolve()
        })
        .catch(error => {
          if (
            error.response.data.code !== 'IRREGULAR_LABORATORY' &&
            !rootState.authentication.profile.defaulter
          ) {
            notify({
              title: 'AVISO:',
              message: ERROR_TRANSFER_OS,
              action: {
                title: 'ATUALIZAR',
                handler: reload,
              },
            })
          } else {
            analytics.pushAnalyticsEvent('error-validation', {
              'msg-error': 'irregular-laboratory',
            })
            dispatch('showIrregularModal', true)
          }
          reject()
        })
    })
  },
  setOrderShowOff({ commit }, value) {
    commit(OS_FILTER_SHOW_OFF, value)
  },
  performTransferOs: function ({ state, dispatch, commit, rootState }, selectedItems) {
    return new Promise((resolve, reject) => {
      commit(OS_SET_LAST_TRANSFERED_LIST, selectedItems)
      let itensError = false
      itensError = selectedItems.some(e => e.status === 'E')

      if (itensError) {
        notify({
          title: 'AVISO:',
          message: 'As Ordens de Serviço com erro serão transferidas parcialmente.',
        })
      }
      orderService
        .performTransfer(selectedItems)
        .then(response => {
          let totalOS = selectedItems.length

          this.osTimeTransfer = totalOS * 5 * 1000

          if (this.osTimeTransfer < 10000) {
            this.osTimeTransfer = 10000
          } else if (this.osTimeTransfer > 60000) {
            this.osTimeTransfer = 60000
          }
          setTimeout(() => {
            router.push('/print-tag/samples')
            dispatch('clearLastTransferredList')
            resolve()
            notify({
              title: 'AVISO:',
              message: 'OSˊs importadas estarão disponíveis em instantes.',
              action: {
                title: 'ATUALIZAR',
                handler: reload,
              },
            })
          }, this.osTimeTransfer)
        })
        .catch(error => {
          if (
            error.response.data.code !== 'IRREGULAR_LABORATORY' &&
            !rootState.authentication.profile.defaulter
          ) {
            notify({
              title: 'AVISO:',
              message: ERROR_TRANSFER_OS,
              action: {
                title: 'ATUALIZAR',
                handler: reload,
              },
            })
          } else {
            analytics.pushAnalyticsEvent('error-validation', {
              'msg-error': 'irregular-laboratory',
            })
            dispatch('showIrregularModal', true)
          }
          reject()
        })
    })
  },
  performTransferOsSpinner: function (
    { state, dispatch, commit, rootState },
    selectedItems
  ) {
    return new Promise((resolve, reject) => {
      commit(OS_SET_LAST_TRANSFERED_LIST, selectedItems)
      let itensError = false
      itensError = selectedItems.some(e => e.status === 'E')

      if (itensError) {
        notify({
          title: 'AVISO:',
          message: 'As Ordens de Serviço com erro serão transferidas parcialmente.',
        })
      }
      orderService
        .performTransfer(selectedItems)
        .then(() => {
          resolve()
        })
        .catch(error => {
          if (
            error.response.data.code !== 'IRREGULAR_LABORATORY' &&
            !rootState.authentication.profile.defaulter
          ) {
            notify({
              title: 'AVISO:',
              message: ERROR_TRANSFER_OS,
              action: {
                title: 'ATUALIZAR',
                handler: reload,
              },
            })
          } else {
            analytics.pushAnalyticsEvent('error-validation', {
              'msg-error': 'irregular-laboratory',
            })
            dispatch('showIrregularModal', true)
          }
          reject()
        })
    })
  },
  addPatient({ commit, rootGetters }, patient) {
    let patientFormated = {
      editing: false,
      date: patient.collectDate ? Moment(patient.collectDate).format('DD/MM/YYYY') : '',
      time: patient.collectTime,
      code_lis: patient.osIdLis.replace(/\s/g, ''),
      notes: patient.comments,
      patient: {
        name: patient.name,
        code_lis: patient.idLis.replace(/\s/g, ''),
        gender: patient.gender.value,
        birthdate: Moment(patient.birthDate).format('DD/MM/YYYY'),
        cpf: patient.cpf,
        social_name: patient.social_name ? patient.social_name : null,
      },
      ...(patient.height && {
        biometric_data: {
          height:
            typeof patient.height === 'string'
              ? parseFloat(patient.height.replace(/\D/g, '.'))
              : patient.height,
          weight:
            typeof patient.weight === 'string'
              ? parseFloat(patient.weight.replace(/\D/g, '.'))
              : patient.weight,
          bmi: parseFloat(patient.bmi.toString().replace(',', '.')),
          smoker: patient.smoker,
          diabetic: patient.diabetic ? patient.diabetic : patient.diabetic,
          diastolic_blood_pressure:
            typeof patient.diastolic_blood_pressure === 'string'
              ? parseFloat(patient.diastolic_blood_pressure.replace(/[^0-9]/g, ''))
              : patient.diastolic_blood_pressure,
          systolic_blood_pressure:
            typeof patient.systolic_blood_pressure === 'string'
              ? parseFloat(patient.systolic_blood_pressure.replace(/[^0-9]/g, ''))
              : patient.systolic_blood_pressure,
          abdominal_circumference:
            typeof patient.abdominal_circumference === 'string'
              ? parseFloat(patient.abdominal_circumference.replace(/[^0-9]/g, ''))
              : patient.abdominal_circumference,
        },
      }),
      doctor: {
        name: patient.doctor.name,
        crm: patient.doctor.id,
        state: patient.doctor.state ? patient.doctor.state.value : null,
      },
    }

    if (rootGetters.toggle.collectPlace) {
      if (patient.collectionPointName) {
        patientFormated.collectionPointName = patient.collectionPointName
          .trim()
          .replace(/[^a-zA-Z0-9 ]/g, '')
          .replace(/\s{2,}/g, ' ')
      }
    }
    commit(OS_ADD_NEW_PATIENT, patientFormated)
  },
  editPatient({ commit, state }) {
    commit(OS_EDIT_NEW_PATIENT)
  },
  createOs: function ({ state, dispatch, rootState }, param) {
    let analyticsStartTime = Moment(new Date())

    let id = param.id
    let newOrder = deepCloneObj(state.newPatient)

    if (!newOrder.doctor.name && !newOrder.doctor.crm && !newOrder.doctor.state) {
      delete newOrder.doctor
    }
    newOrder.voucher = param.isVoucher
    newOrder.exams = rootState.exam.newExams
    newOrder.version = state.version

    if (newOrder.exams.filter(order => order.details.code === 'SEXA').length) {
      newOrder.exams = newOrder.exams.map(exam => ({
        ...exam,
        additional_field_values: exam.additional_field_values.map(
          additionalFieldValues => ({
            ...additionalFieldValues,
            value: Moment.isDate(additionalFieldValues.value)
              ? Moment(additionalFieldValues.value, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : additionalFieldValues.value,
          })
        ),
      }))
    }

    if (param.recollect) {
      newOrder.idRecollect = param.recollect
    }

    let type = newOrder.voucher
      ? 'Voucher interlaboratorial salvo'
      : 'Ordem de Serviço salva'

    if (id) {
      return orderService.editOS(newOrder, id).then(response => {
        notify({
          title: 'AVISO:',
          message: type + ' com sucesso.',
        })
        analyticsForRequestTime({ startTime: analyticsStartTime, action: 'Edição de OS' })
      })
    } else {
      return orderService.createOs(newOrder).then(() => {
        notify({
          title: 'AVISO:',
          message: type + ' com sucesso.',
        })
        analyticsForRequestTime({
          startTime: analyticsStartTime,
          action: 'Cadastro de OS',
        })
      })
    }
  },
  clearAllNewOrderData: function ({ commit }) {
    commit(OS_CLEAR_NEW_ORDER_DATA)
    commit(EXAM_CLEAR_NEW_DATA)
  },
  getEditOS: function ({ commit, dispatch }, orderId) {
    return new Promise(async (resolve, reject) => {
      let response = await orderService.getOs(orderId)
      commit(OS_SET_VERSION, response.data.version)
      await dispatch('validateEditOSErros', response)
      resolve(response)
    })
  },
  validateEditOSErros: function ({ dispatch, commit, state }, response) {
    return new Promise(async (resolve, reject) => {
      let examError = 0
      for (let exam of response.data.exams) {
        if (exam.id !== 0) {
          let examId = response.data.requestId ? exam.mnemonic : exam.id
          dispatch('pushLoadingExam', examId)

          try {
            await processExamForEditing(response, exam, commit, dispatch, state)
          } catch (error) {
            dispatch('removeLoadingExam', exam.id)
            if (
              error.response.data.code === 'INVALID_RESTRICTION' ||
              error.response.data.code === 'DISABLED'
            ) {
              examError++
            } else {
              reject()
            }
          }
        } else {
          examError++
        }
      }
      if (examError > 0) {
        notify({
          title: 'AVISO:',
          message:
            examError +
            (examError > 1
              ? ' Exames com erro não constam na lista de exames'
              : ' Exame com erro não consta na lista de exames'),
        })
      }
      resolve()
    })
  },
  showMessage: function ({ state }, messagens) {
    showMessage(messagens)
  },
  deleteExamOrder: function ({ state, dispatch, commit }, object) {
    let indexOrder = state.orders.indexOf(object.order)
    if (object.order.exams.length > 1) {
      object.indexOrder = indexOrder
      orderService
        .deleteExamOrder(object.order.id, object.exam.id)
        .then(response => {
          commit(OS_DELETE_EXAM_ORDER, object)
          notify({
            title: 'AVISO:',
            message: 'Exame excluído com sucesso.',
          })
          dispatch('countTotalOrdersWithDocPending')
        })
        .catch(() => {
          commit(OS_SET_LOADING_STATUS, 'STATUS_INITIAL')
          dispatch('showMessage', ERROR_DELETE_EXAM_ORDER)
        })
    } else {
      dispatch('deleteOrder', indexOrder).then(response => {
        notify({
          title: 'AVISO:',
          message: 'Exame excluído com sucesso.',
        })
        dispatch('countTotalOrdersWithDocPending')
      })
    }
  },
  setWaitingOSLoadingStatus: function ({ commit }) {
    commit(OS_SET_LOADING_STATUS, 'STATUS_WAITING')
  },
  selectOSList: function ({ commit }, ordersList) {
    commit(OS_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(OS_SET_LIST, ordersList)
  },
  sortOSList: function ({ commit }, param) {
    commit(OS_SORT_LIST, param)
  },
  getTotalOrder: function ({ commit, state }) {
    let filter = builderStatusAndStates(state.filterBy)
    let lastTransferedList = state.filterBy === 'F' ? state.lastTransferedList : []

    orderService
      .countTotalOrders(
        state.offset,
        strings.listsLimits.orders,
        filter.status,
        filter.states,
        state.q,
        lastTransferedList
      )
      .then(response => {
        commit(OS_TOTAL_COUNT, response.data.ordersTotalCount)
      })
  },
  breakOrdersLoading: function ({ commit }) {
    commit(OS_SET_LOADING_STATUS, 'STATUS_FINAL')
    commit(OS_CLEAR)
    commit(OS_CLEAR_OFFSET)
    commit(OS_SET_MODIFIED, 0)
    commit(OS_SET_ERROR, 0)
    commit(OS_SET_CORRECT, 0)
    commit(OS_BREAK_STATUS, true)
    window.stop()
  },
  includeNewExamAfterTransferred: function ({ state, dispatch, rootState }, orderId) {
    let newOrder = deepCloneObj(state.newPatient)

    newOrder.exams = rootState.exam.newExams
    newOrder.version = state.version
    return orderService
      .insertNewExamAfterTransfered(newOrder, orderId)
      .then(response => {
        if (response.status === 200) {
          notify({
            title: 'AVISO:',
            message: 'Exame incluído na OS com sucesso.',
          })
        }
      })
      .catch(error => {
        if (
          error.response.data.code === 'IRREGULAR_LABORATORY' ||
          rootState.authentication.profile.defaulter
        ) {
          analytics.pushAnalyticsEvent('error-validation', {
            'msg-error': 'irregular-laboratory',
          })
          dispatch('showIrregularModal', true)
        } else {
          let errorMsg = 'Não foi possível incluir exame na OS'
          notify({
            title: 'AVISO:',
            message: error.response.data.message ? error.response.data.message : errorMsg,
          })
        }
      })
  },
  deleteNewExamAfterTransfered: function ({ state, dispatch, rootState }, order) {
    return orderService
      .deleteNewExamAfterTransfered(order.orderId, order.examId)
      .then(response => {
        if (response.status === 200) {
          notify({
            title: 'AVISO:',
            message: 'Exame excluído com sucesso da OS',
          })
        }
      })
      .catch(error => {
        if (
          error.response.data.code === 'IRREGULAR_LABORATORY' ||
          rootState.authentication.profile.defaulter
        ) {
          analytics.pushAnalyticsEvent('error-validation', {
            'msg-error': 'irregular-laboratory',
          })
          dispatch('showIrregularModal', true)
        } else {
          let errorMsg = 'Não foi possível excluir exame na OS'
          notify({
            title: 'AVISO:',
            message: error.response.data.message ? error.response.data.message : errorMsg,
          })
        }
      })
  },
  setEditingOrder: function ({ commit }, value) {
    commit(OS_EDITING_STATUS, value)
  },
  getTotalSamplesFromTransferring: function ({ state, commit }) {
    commit(OS_SET_TRANSFER_REPORT_LOADING, 'STATUS_LOADING')

    setTimeout(function () {
      sampleService
        .countTotalSample({
          limit: strings.listsLimits.orders,
          orderIds: state.lastTransferedList,
        })
        .then(response => {
          commit(OS_SET_TRANSFER_REPORT, response.data)
          commit(OS_SET_TRANSFER_REPORT_LOADING, 'STATUS_SUCCESS')
        })
        .catch(() => {
          commit(OS_SET_TRANSFER_REPORT_LOADING, 'STATUS_FAILED')
          commit(OS_SET_TRANSFER_REPORT, {
            failTransmitOrdersCount: -1,
            samplesCount: -1,
          })
        })
    }, 500)
  },
  clearLastTransferredList: function ({ commit }) {
    commit(OS_CLEAR_LAST_TRANSFERED_LIST)
  },
  countTotalOrdersWithDocPending: function ({ commit, state }) {
    let total = Object.keys(state.orders).reduce((previous, key) => {
      return previous + state.orders[key].pendingDocCount
    }, 0)

    commit(OS_SET_TOTAL_EXAMS_DOC_PENDING, total)
  },
  getPendingDocumentsTotalNumber: async function ({ commit }) {
    try {
      const response = await orderService.getCountFilterDocuments()
      commit(OS_SET_PENDING_DOCUMENTS_TOTAL, response.data?.ordersTotalCount ?? 0)
    } catch (error) {
      commit(OS_SET_PENDING_DOCUMENTS_TOTAL, 0)
    }
  },
}

let processExamForEditing = function (order, exam, commit, dispatch, state) {
  return new Promise((resolve, reject) => {
    let getExamDetails
    let param

    if (order.data.requestId) {
      getExamDetails = examService.getExamDetailsByMnemonic
      param = exam.mnemonic

      if (
        exam.mnemonic.indexOf('.') > -1 &&
        window.location.pathname.indexOf('recollect') > -1
      ) {
        getExamDetails = examService.getExamDetailsById
        param = exam.id
      } else {
        getExamDetails = examService.getExamDetailsByMnemonic
        param = exam.mnemonic
      }
    } else {
      getExamDetails = examService.getExamDetailsById
      param = exam.id
    }

    getExamDetails(param)
      .then(response => {
        let examDetails = response.data

        examDetails.id_exam_order = exam.id_exam_order
        examDetails.code_origin_lis = exam.code_origin_lis
        if (exam.type === EXAM_SIMPLE) {
          if (exam.sample) {
            examDetails.sample = {
              amount: exam.sample.amount,
              material: exam.sample.material,
            }
          }
          examDetails.notes = exam.notes
          examDetails.urgent = exam.urgent
        } else if (exam.type === EXAM_ADITIONAL) {
          if (exam.sample) {
            examDetails.sample = {
              amount: exam.sample.amount,
              material: exam.sample.material,
            }
          }
          examDetails.fields.forEach(function (valueDetails) {
            exam.additional_field_values.forEach(function (value) {
              if (valueDetails.id === value.id_field) {
                valueDetails.value = value.value
              }
            })
          })
          examDetails.notes = exam.notes
          examDetails.urgent = exam.urgent
        } else if (exam.type === EXAM_CURVE) {
          let hashCollectTimes = {}
          examDetails.collectTimes.forEach(function (collectTime) {
            hashCollectTimes[collectTime.id.toString()] = {
              id: collectTime.id,
              value: false,
              time: collectTime.time,
              processing_origin: order.data.processing_origin,
              order: collectTime.order,
            }
          })

          examDetails.sample = { material: exam.sample.material }
          if (exam.sample && !state.orderClone) {
            exam.sample.collect_times.forEach(function (index) {
              hashCollectTimes[index.toString()].value = true
            })
          }
          examDetails.collectTimes = hashCollectTimes
          examDetails.notes = exam.notes
        } else {
          if (exam.sample) {
            examDetails.sample = {
              amount: exam.sample.amount,
              material: exam.sample.material,
            }
          }
          examDetails.notes = exam.notes
          examDetails.urgent = exam.urgent
          examDetails.judge_name = exam.judge_name
          examDetails.collector_name = exam.collector_name
          examDetails.paternity_participants = []
          if (exam.paternity_participants) {
            exam.paternity_participants.forEach(element => {
              element.genderCombo = strings.genders.filter(
                gender => gender.value === element.gender
              )[0]
              element.relationshipCombo = strings.participantsRelationship.filter(
                relationship => relationship.value === element.relationship
              )[0]
              // alterar para suposta mãe
              // if (examDetails.code === 'PAT' || element.relationshipCombo.value === 'C') {
              element.disabled = true
              // }
              examDetails.paternity_participants.push(element)
            })
          }
        }
        // Recollect Order
        if (order.data.requestId) {
          examDetails.recollect = true
        }
        dispatch('createExam', examDetails).then(response => {
          commit(EXAM_ADD_NEW, response)
        })
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  })
}

let reload = function () {
  window.location.reload()
}

let analyticsOnTransmittedOrders = function (label) {
  analytics.pushAnalyticsEvent('ga-event', {
    category: 'Listagem de OS - Status OS',
    action: 'Numero de OS na listagem',
    label: label,
  })
}

let analyticsOnReloadPage = function () {
  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('vpageview', {
      page: 'setIds',
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName,
    })
  }
}

let showMessage = function (messagens) {
  notify({
    title: 'AVISO:',
    message: messagens,
  })
}

let analyticsOnFetchingFromSearch = function (query) {
  analytics.pushAnalyticsEvent('ga-search', {
    q: query.q,
    from: query.status,
    to: query.states,
    idFile: state.idFile,
    docDelivered: state.docDelivered,
    findTypeOrderResultFilter: state.findTypeOrderResultFilter,
  })
}

let builderStatusAndStates = filterBy => {
  let builder = Object
  builder.status = []
  builder.states = []

  if (Array.isArray(filterBy)) {
    filterBy.forEach(selected => {
      if (strings.filterState.includes(selected)) {
        builder.states.push(selected)
      } else {
        builder.status.push(selected)
      }
    })
  } else {
    if (filterBy === 'P') {
      builder.states.push('V')
      builder.states.push('P')
    } else if (strings.filterState.includes(filterBy)) {
      builder.states.push(filterBy)
    } else if (typeof filterBy !== 'undefined' && filterBy !== null) {
      builder.status.push(filterBy)
    }
  }

  if (builder.states.length > 0 && builder.states.includes('P')) {
    builder.states.push('V')
  }
  return builder
}

let analyticsForRequestTime = ({ startTime, action }) => {
  let endTime = Moment(new Date())
  let totalTime = endTime.diff(startTime, 'seconds')

  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'Cadastro Manual',
      action: 'Tempo de ' + action,
      label: totalTime,
      value: totalTime,
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName,
    })
  }
}

let decorateOrderDetail = orderDetail => {
  orderDetail.exams.map(exam => {
    exam.samples.map(sample => {
      if (exam.status === 'F' || exam.status === 'E') {
        sample.material_fixed =
          sample.material.name !== sample.material_sent ? sample.material.name : ''
      }
    })
  })
  return orderDetail
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
